import { createAction } from '@reduxjs/toolkit';
import { LevelType, SpaceType } from 'data/types';
import { SpaceWallReconcileRequestType } from './structure-reconcile-types';

export const reconcileSpaceWallsRequested = createAction<
  SpaceWallReconcileRequestType[]
>('structure/reconcileSpaceWallsRequested');

function findStructureSpace(
  structure: LevelType[],
  spaceId: string
): SpaceType | null {
  for (const level of structure) {
    for (const section of level.sections) {
      const space = section.spaces.find((entry) => entry.uniqueId === spaceId);
      if (space) {
        return space;
      }
    }
  }
  return null;
}

export function wallReconcileRequestsFor(
  previousStructure: LevelType[],
  spaceIds: Iterable<string>
): SpaceWallReconcileRequestType[] {
  return [...new Set(spaceIds)].map((spaceId) => ({
    spaceId,
    previousSpace: findStructureSpace(previousStructure, spaceId)
  }));
}
